import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * What an unmatched URL shows. Required by STORY-0.10.6 ("Given navigation na nepostojeći URL, Then
 * 404 page") since 2026-05-02, and implemented 2026-10-08.
 *
 * Until now main.tsx mounted the legacy mockup (App.jsx) on the catch-all `path="/*"` behind
 * RequireAuth alone. So an unmatched path did not 404 — it rendered fabricated KPIs, orders and
 * pumps from components/data.jsx, outside AppShell, with no navigation back and the URL unchanged
 * while the user clicked through eight more fake screens. Four links the backend itself sent landed
 * there (see EveryLinkWeSendResolvesToARouteTest); those are fixed, but a URL typed, pasted from an
 * old note or followed from an archived e-mail would land there too, and no guard can cover that.
 *
 * Deliberately mirrors ForbiddenPage rather than sharing a component with it: the two differ only in
 * their copy today, and extracting a shared shell for two small pages would be an abstraction built
 * on a resemblance rather than on a rule.
 */
export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div style={shell}>
      <div style={card}>
        <h1 style={{ margin: 0, color: "#6b7280", fontSize: 28 }}>{t("notFound.code")}</h1>
        <p style={{ margin: 0, fontSize: 18, color: "#1f2937" }}>{t("notFound.title")}</p>
        <p style={{ margin: 0, color: "#6b7280", fontSize: 14 }}>{t("notFound.message")}</p>
        <Link to="/dashboard" style={{ color: "#0b3a6f", fontSize: 14 }}>
          {t("notFound.back")}
        </Link>
      </div>
    </div>
  );
}

const shell: React.CSSProperties = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#f4f6f8",
};
const card: React.CSSProperties = {
  background: "#fff",
  padding: 32,
  borderRadius: 12,
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  gap: 12,
  boxShadow: "0 1px 3px rgba(0,0,0,.08)",
};
